import { Banner, Button } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type FetchingErrorBannerProps = {
  resourceName: string;
  title?: string;
  message?: string;
};

const FetchingErrorBanner = ({
  resourceName,
  title,
  message,
}: FetchingErrorBannerProps) => {
  const { t } = useTranslation('components');

  return (
    <Banner
      id={`${resourceName}-error-banner`}
      isFlat
      isFullWidth
      intent="error"
      title={title ?? t('fetchingErrorBanner.defaultTitle', { resourceName })}
      message={
        message ?? t('fetchingErrorBanner.defaultMessage', { resourceName })
      }
      cta={
        <Button
          id={`${resourceName}-refresh-page-button`}
          variant="outline"
          intent="danger"
          onClick={() => window.location.reload()}>
          {t('fetchingErrorBanner.refreshPage')}
        </Button>
      }
    />
  );
};

export default FetchingErrorBanner;
